import { ICategory } from "web/types/Category";
import { ICategoryCount } from "web/types/CategoryCount";
import { ICategoryMenuItem, MenuItemType } from "web/types/Menu";

import getUrlAndCount from "./getUrlAndCount";

interface IHandleCategoryArgs {
  menuItem: ICategoryMenuItem<MenuItemType.CATEGORY>;
  categories: ICategory[];
  counts: ICategoryCount[];
}

const handleCategory = ({
  menuItem,
  categories,
  counts,
}: IHandleCategoryArgs) => {
  const { url, count } = getUrlAndCount({
    id: +menuItem.id_category,
    categories,
    counts,
  });

  return url && count
    ? {
        ...menuItem,
        category_request_path: url,
        category_products_count: count,
      }
    : null;
};

export default handleCategory;
